// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sch8G","content":"styles_content__NbBsf"};